import { BASE_METHODS, CustomErrorType } from "../../constants/action-types";
import {
  removeCompanyFromCompanies,
  setCompanyActionStart,
  setCompanyErrorMessage,
} from "../../constants/reducers/company.reducer";
import { store } from "../../store";
import { createCall } from "../base";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";
import { AxiosResponse } from "axios";
import { SuccessDTO } from "../../constants/dto/success";

type DeleteCompanyProp = {
  id: number;
};

let body: SuccessDTO;

export const deleteCompany = async ({ id }: DeleteCompanyProp) => {
  store.dispatch(setCompanyActionStart(true));
  const request = await createCall(
    `cms/companies/delete/${id}`,
    BASE_METHODS.DELETE,
    "application/json",
    "1.0.0",
    undefined,
    undefined
  );

  try {
    const response = request as AxiosResponse;
    body = plainToClass(SuccessDTO, response.data);
    const errors = await validate(body);
    if (errors.length > 0) {
      store.dispatch(
        setCompanyErrorMessage(TextEnum.DELETE_COMPANY_INVALID_RESPONSE)
      );
      return;
    }
    store.dispatch(removeCompanyFromCompanies(id));
    return response;
  } catch (error) {
    const responseError = request as any;
    const errorResponeData: CustomErrorType = responseError.response?.data;
    if (errorResponeData) {
      let errorMessage = "";
      switch (errorResponeData.code) {
        case 2001:
          errorMessage = TextEnum.DELETE_COMPANY_COMPANY_NOT_FOUND;
          break;
        default:
          break;
      }
      store.dispatch(setCompanyErrorMessage(errorMessage));
      return;
    }
    store.dispatch(setCompanyActionStart(false));
    store.dispatch(timeoutError());
    return;
  }
};
